/* global femcare */

/**
 * Represents the newsletter popup functionality.
 */
femcare.newsletter.popupNewsletter = {

    $floatingButtonWrapper: $('.floating-button-wrapper'),

    /**
     * Initializes the newsletter popup functionality if user isn't already signed up.
     */
    init: function () {
        if (this.$floatingButtonWrapper.length) {
            if ((this.shouldShowFloatingButton('hide_floating_button')) && (this.shouldShowFloatingButton('newsletter_signup'))) {
                this.$floatingButtonWrapper.addClass('floating-button-wrapper--shown');
                $('.floating-button__close').on('click', this.hideFloatingButton.bind(this));

                if ($(window).width() < 1024) {
                    this.enableMobileDrag();
                }

                this.showHidePopupNewsletter();
            }
        }
    },

    /**
     * Checks if the floating button should be shown in the current session, in relation to the present cookies.
     * @param {string} cookieName - The cookie value.
     * @returns {boolean} True if the floating button should be shown, false otherwise.
     */
    shouldShowFloatingButton: function (cookieName) {
        var cookieValue = this.getCookie(cookieName);

        return cookieValue === 'false' || cookieValue === '';
    },

    /**
     * Retrieves the value of a cookie by name.
     * @param {string} name - The name of the cookie.
     * @returns {string} The value of the cookie.
     */
    getCookie: function (name) {
        var cookieValue = '';
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i].trim();
            if (cookie.startsWith(name + '=')) {
                cookieValue = cookie.substring(name.length + 1);
                break;
            }
        }

        return cookieValue;
    },

    /**
     * Attaches the event handlers to floating button, modal close button and backdrop.
     * Shows and hides the popup newsletter modal component.
     */
    showHidePopupNewsletter: function () {
        var $newsletterModal = $('.newsletter-modal');
        var $body = $('body');

        if ($newsletterModal.length) {
            var $floatingButtonOpen = $('.floating-button__open');
            var $closeButton = $newsletterModal.find('.close');

            $floatingButtonOpen.on('click', function () {
                $newsletterModal.addClass('modal--opened in');
                $body.css('overflow-y', 'hidden');
            });

            $closeButton.on('click', function () {
                $newsletterModal.removeClass('modal--opened');
                $body.css('overflow-y', 'auto');
            });

            // Close the modal when clicking outside the modal content
            $newsletterModal.on('click', function (event) {
                if (!$(event.target).closest('.modal-content').length) {
                    $newsletterModal.removeClass('modal--opened');
                    $body.css('overflow-y', 'auto');
                }
            });
        }
    },

    /**
     * Hides the floating button wrapper.
     */
    hideFloatingButton: function () {
        this.$floatingButtonWrapper.removeClass('floating-button-wrapper--shown');

        // Save a session cookie, to remember that the button should be hidden
        document.cookie = 'hide_floating_button=true';
    },

    /**
     * Enables dragging of the floating button on mobile devices.
     * Hides button when it's dragged over setted threshold.
     */
    enableMobileDrag: function () {
        var isDragging = false;
        var startX = 0;
        var threshold = 50; // Drag threshold in pixels
        var $floatingButton = $('.floating-button');

        $floatingButton.on('touchstart', function (e) {
            startX = e.originalEvent.touches[0].clientX;
        });

        $floatingButton.on('touchmove', function (e) {
            var currentX = e.originalEvent.touches[0].clientX;
            var distance = currentX - startX;

            if (Math.abs(distance) > threshold && !isDragging) {
                isDragging = true;
                $floatingButton.addClass('floating-button--dragging');
            }
        });

        $(window).on('touchend', function () {
            if (isDragging) {
                $floatingButton.removeClass('floating-button--dragging');
                this.hideFloatingButton();
            }
            isDragging = false;
        }.bind(this));
    },
};
